module.exports = __webpack_public_path__ + "img/36.b33d4cd0.webp";